import { createContext, useContext } from "react";
import DefaultMeetingStore, { MeetingStore } from "../customerMeetings/store/MeetingStore";

export interface IStore {
    meetingStore: MeetingStore;
}

export const store: IStore = {
    meetingStore: DefaultMeetingStore,
};

export const StoreContext = createContext(store);

export const useStore = () => {
    return useContext(StoreContext);
};
